import React, { useState } from 'react'
import { firestore } from '../../firebase';

function AddLoanProvider() {

    const [bank, setBank] = useState("");
    const [rente, setRente] = useState(0);
    const [type, setType] = useState("");

    const [error, setError] = useState("");

    async function submitHandler(e) {
        e.preventDefault();
        try {
            const loanRef = firestore.collection("renter");
            const data = {
                bank,
                rente: +rente,
                rente_type: type
            }
            loanRef.add(data);
        } catch (error) {
            
        }
    }

    return (
        <form onSubmit={submitHandler}>

            <label>Bank</label>
            <input className="form-control mb-2" value={bank} onChange={e => setBank(e.target.value)} />

            <label>Rente</label>
            <input type="number" className="form-control mb-2" value={rente} onChange={e => setRente(e.target.value)} />

            <label>Rente type</label>
            <input className="form-control mb-2" value={type} onChange={e => setType(e.target.value)} />

            {error && <div className="alert alert-danger">{error}</div>}
            <button className="btn btn-success btn-block">Legg til</button>

        </form>
    )

}
export default AddLoanProvider;